// extracted by mini-css-extract-plugin
export default {"spacer":"style_spacer__mg3h2","s24":"style_s24__SYLIo","s16":"style_s16__8qSlI","s10":"style_s10__VVcBF"};